/**
 * Les thèmes de l'application (« skins »).
 *
 * Trois sont débloqués d'office : sombre, clair et « classique » — le bleu
 * nuit et l'or du premier prototype. D'autres s'achèteront plus tard avec les
 * pièces gagnées en se rencontrant ; jamais avec de l'argent.
 *
 * Le choix vit sur l'appareil (localStorage). Les couleurs elles-mêmes sont
 * dans `hoa.css`, sous `[data-skin]`, et dans `assets/skins/*.json` à la
 * racine du projet pour qui les reprendra ailleurs.
 */

export type SkinId = "dark" | "light" | "classic";

export interface Skin {
  id: SkinId;
  nom: string;
  /** Aperçu : fond, texte, secondaire, accent. */
  apercu: [string, string, string, string];
  /** Couleur de la barre du navigateur. */
  barre: string;
}

export const SKINS: readonly Skin[] = [
  { id: "dark", nom: "Sombre", apercu: ["#161616", "#FFFFFF", "#5A5A5A", "#FFFFFF"], barre: "#161616" },
  { id: "light", nom: "Clair", apercu: ["#F4F4F4", "#111111", "#BDBDBD", "#111111"], barre: "#F4F4F4" },
  { id: "classic", nom: "Classique", apercu: ["#1C2440", "#F2DFBD", "#3A4360", "#DCAE63"], barre: "#1C2440" },
];

const CLE = "hoa.skin";

export function lireSkin(): SkinId {
  try {
    const v = localStorage.getItem(CLE);
    if (v === "dark" || v === "light" || v === "classic") return v;
  } catch {
    /* navigation privée */
  }
  return "dark";
}

export function ecrireSkin(id: SkinId): void {
  try {
    localStorage.setItem(CLE, id);
  } catch {
    /* navigation privée : le choix vaut pour la visite */
  }
  appliquerBarre(id);
}

export function appliquerBarre(id: SkinId): void {
  const meta = document.querySelector('meta[name="theme-color"]');
  const skin = SKINS.find((s) => s.id === id);
  if (meta && skin) meta.setAttribute("content", skin.barre);
}
